import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import "./assets/css/index.css";

// router setup
import router from "./routes/router";
import store from "./store";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import './assets/tailwind.css'
// plugin setup
Vue.use(DashboardPlugin);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store
});
